import React from 'react';

/**
 * WebSiteSchema Component
 * CRITICAL for Google Sitelinks Search Box and AI understanding of site structure
 * Also enables "Hey Siri/Google" to understand your site's search capability
 * 
 * IMPORTANT: Renders inline so Google can see it on first crawl
 */
const WebSiteSchema = () => {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://audioandco.com/#website",
    "url": "https://audioandco.com",
    "name": "Audio & Co®",
    "alternateName": ["Audio and Co", "AudioandCo"],
    "description": "Professional done-for-you podcast production, YouTube management, book publishing, audiobook creation, and mobile app development for small businesses and entrepreneurs.",
    "publisher": {
      "@id": "https://audioandco.com/#organization"
    },
    "inLanguage": "en-GB",
    "potentialAction": [
      {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://audioandco.com/search?q={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    ],
    "copyrightYear": "2019",
    "copyrightHolder": {
      "@id": "https://audioandco.com/#organization"
    }
  };

  return (
    <script
      type="application/ld+json"
      data-schema="website"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
    />
  );
};

export default WebSiteSchema;
